
import React, { useState } from 'react';
import { API_URL } from '../config';

export default function LoginScreen({ onLogin, loading }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        body: JSON.stringify({ email, password })
        , signal: controller.signal });
      clearTimeout(timeout);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status} ${res.statusText}: ${text?.slice(0,200)}`);
      }
      const data = await res.json();
      if (data.ok && data.token && data.usuario) {
        onLogin(data.token, data.usuario.id, data.usuario.role, data.usuario.uid);
      } else {
        setError(data.msg || 'Credenciales incorrectas');
      }
    } catch (err) {
      console.error('Login request failed', { apiUrl: API_URL, error: err });
      let msg;
      if (err && err.name === 'AbortError') {
        msg = 'Tiempo de espera agotado al conectar con el servidor.';
      } else if (!window.navigator.onLine) {
        msg = 'No hay conexión a internet en este dispositivo.';
      } else if (err instanceof TypeError) {
        msg = `No se pudo conectar con el servidor de acceso (${API_URL}). Verifica que la API remota exista y responda /auth/login.`;
      } else {
        msg = err?.message || 'Error de conexión';
      }
      setError(msg);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0099cc',
    }}>
      <form onSubmit={handleSubmit} style={{
        background: '#fff',
        padding: 32,
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        minWidth: 320,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
  <img src="/logo.png" alt="Logo" style={{ width: 64, marginBottom: 16 }} />
        <h2 style={{ color: '#0099cc', marginBottom: 24 }}>Iniciar sesión</h2>
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{
            marginBottom: 16,
            padding: '10px 14px',
            borderRadius: 8,
            border: '1px solid #b0bec5',
            width: '100%',
            fontSize: 16
          }}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{
            marginBottom: 24,
            padding: '10px 14px',
            borderRadius: 8,
            border: '1px solid #b0bec5',
            width: '100%',
            fontSize: 16
          }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            background: '#0099cc',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '12px 0',
            width: '100%',
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 12
          }}
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
        {error && <div style={{ color: '#e53935', marginTop: 8 }}>{error}</div>}
      </form>
    </div>
  );
}
